import { companies } from "@/apis/companies";

export const APIS = {
  companies,
};
